import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

import { CoreModule } from 'src/app/core/core.module';
import { EditorModule as TinyMceEditorModule } from '@tinymce/tinymce-angular';
import { FileUploadModule } from 'primeng/fileupload';
import { AddressChipsComponent } from './address-chips/address-chips.component';
import { ComposeDialogComponent } from './compose-dialog/compose-dialog.component';
import { FolderTreeComponent } from './folder-tree/folder-tree.component';
import { FoldersManagerComponent } from './folders-manager/folders-manager.component';
import { MailboxRoutingModule } from './mailbox-routing.module';
import { MailboxPageComponent } from './mailbox-page/mailbox-page.component';
import { MessageBodyComponent } from './message-body/message-body.component';
import { MessageListComponent } from './message-list/message-list.component';
import { MessageViewComponent } from './message-view/message-view.component';

/// Lector de correo integrado.
///
/// Va en un módulo propio y no dentro de `mails-accounts` porque son cosas distintas: aquel es la configuración de
/// las cuentas (con los permisos MAIL_ACCOUNTS.*) y este es la pantalla de trabajo del buzón (con MAILBOX.*). Y
/// necesita otro juego de componentes de PrimeNG, que no hay motivo para cargar en una pantalla de ajustes.
///
/// `MessageBodyComponent` se exporta a propósito: es el visor aislado del cuerpo de un correo, y sirve también
/// para sustituir el `[innerHTML]` del historial del expediente, donde hoy los correos se ven sin estilos.
@NgModule({ declarations: [
        MailboxPageComponent,
        FolderTreeComponent,
        MessageListComponent,
        MessageViewComponent,
        MessageBodyComponent,
        FoldersManagerComponent,
        AddressChipsComponent,
        ComposeDialogComponent
    ],
    exports: [
        MessageBodyComponent,
        AddressChipsComponent
    ], imports: [CommonModule,
        CoreModule,
        MailboxRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        CardModule,
        ConfirmDialogModule,
        DialogModule,
        FileUploadModule,
        InputSwitchModule,
        InputTextModule,
        MessagesModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        SkeletonModule,
        TableModule,
        TagModule,
        TieredMenuModule,
        TooltipModule,
        TreeModule,
        TinyMceEditorModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class MailboxModule { }
